import React, { useEffect } from "react";
import styled from "@mui/system/styled";
import { useCallCenterForm } from "../hooks/useCallCenterForm";

import TextField from "@mui/material/TextField";

const TextInput = styled(TextField)(() => ({
  padding: "4px",
}));

const Address2 = () => {
  const { errors, formValues, handleInputChange, handleInputFocus } =
    useCallCenterForm();

  useEffect(() => {}, [formValues]);

  const handleErrorText = () => {
    if (!errors?.address2) {
      return null;
    }

    return errors?.address2;
  };

  return (
    <TextInput
      sx={{ flex: 1 }}
      name="address2"
      label="Address 2"
      onChange={handleInputChange}
      onFocus={handleInputFocus}
      value={formValues?.address2}
      helperText={handleErrorText()}
      error={!!errors?.address2}
    />
  );
};

export default Address2;
